const Formal = {
  baseUrl: "https://51zl.zcunsoft.com",
}
const Test = {
  // baseUrl: "https://51zl.test.zcunsoft.com",
	baseUrl: "http://localhost:8089",
}
// const kfalltobid = {
//   baseUrl: "https://51zhulitest.alltobid.com",
// }
const url = () => {
	// return kfalltobid
	if(window.location.host.indexOf('192.168.3.') >= 0 
	|| window.location.host.indexOf('localhost') >= 0 
	|| window.location.host.indexOf('51zl.test.zcunsoft.com') >= 0)
	{
		return Test;
	}
	if(window.location.host.indexOf('51zl.zcunsoft.com') >= 0){
		return Formal;
	}
}
export {url}


// WEBPACK FOOTER //
// ./src/assets/js/config.js